import Modal from 'react-bootstrap/Modal'

import styled from '@emotion/styled'

export const StyledModal = styled(Modal)`
  .modal-content {
    background-color: var(--background);
  }
`
